module.exports = __webpack_public_path__ + "img/1557614083573882882.4c2334ee.png";